import { makeCall } from '../../../Utility/makeCallText';
import { formatPhone, formatPhoneLink } from '../../../Utility/phoneNumberFormat';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
// import TemplateModal from 'Features/SalesDep/Templates/SelectTemplateModal';
import DeleteBidModal from './DeleteBidModal';
import { SwipeableList, SwipeableListItem, Type as SwipeableType } from 'react-swipeable-list';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { deleteBid, getBidDetails, getBids } from './BidSlice';
import { parseDate } from '../../../Utility/parseDate';
import { Bid } from '../../../Types/Bid';
import RightAction from '../Orders/RightAction';
import Swal from "sweetalert2";
import 'sweetalert2/src/sweetalert2.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase';
import { Button, Card } from 'reactstrap';

type Props = {
    item: Bid;
    onError: (error: string) => void;
}

const RenderBidItem = ({ item, onError }: Props) => {
    const [templateModalOpen, setTemplateModalOpen] = useState<boolean>(false);
    const [deleteModaOpen, setDeleteModalOpen] = useState<boolean>(false);
    const [bidID, setbidID] = useState<string>('');
    const [bidItem, setBidItem] = useState<Bid>();
    const today = new Date();
    const expireDate = new Date(parseDate(item.expires));
    const token = useAppSelector((state) => state.auth.token);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    
    const statusType = (approved: string, expires: Date) => {
        const today = new Date();
        const expireDate = new Date(expires);
    
        if (expireDate > today && approved === 'Y') return 'Approved';
        if (expireDate > today && approved === '') return 'Draft';
        if (item.orders?.[0]?.order) return 'Converted to order';
        if (expireDate <= today) return 'Expired';
    };
    
    const status = statusType(item.approved, expireDate);

    // const bidTotal = item.products.reduce((accumulator, currentProduct) => {
    //     return accumulator + (currentProduct.price * currentProduct.qty)
    // }, 0);

    const handleSeeDetails = (item: Bid) => {
        dispatch(getBidDetails(item.quoteID))
        navigate(`/Orders+Bids/BidDetails/${item.quoteID}`, { state: { item } })
    };

    const handleBidFollowUp = async (item: Bid) => {
        setBidItem(item);
        // const expireDate = parseDate(item.expires)
        // const dif = Math.ceil((expireDate - today) / (1000 * 60 * 60 * 24));
        Swal.fire({
            title: 'Bid Follow-Up',
            text: `This will begin the follow-up process which will require you to choose a contact template. You will have a chance to edit the template before sending to the customer.\n\nProceed?`,
            icon: 'info',
            showCancelButton: true,
            cancelButtonColor: 'red',
            confirmButtonText: 'Continue',
            confirmButtonColor: '#f1b434',
            showLoaderOnConfirm: false,
        }).then((result) => {
            if (result.isConfirmed) {
                setTemplateModalOpen(!templateModalOpen);
            };
        });

        logEvent(analytics, 'bid_followup_web', {
            name: 'bid follow up',
            description: 'User pressed follow up button'
        })
    }

    const alertMessage = `Are you sure? This will permanently close Bid# ${item.quoteID}.`

    const handleSubmit = (template: string) => {
        setTemplateModalOpen(false);
        dispatch(getBidDetails(item.quoteID))
        // navigate('BidDetails', { state: { item }, shareOnOpen: true, template })
    };

    const handleDeleteBid = async (
        bidID: string, 
        value?: string, 
        note?: string,
    ) => {
        try{
            setDeleteModalOpen(false)
            console.log(`deleting bid# ${bidID}, ${value}, ${note}`)
    
            const baseUrl = 'https://customer.hirsch.com/bids/v1'
            const res = await fetch(baseUrl, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                },
                body: JSON.stringify({
                    id: bidID,
                    code: value,
                    note: note
                })
            })
            const json = await res.json();
            if (!json.ack) {
                onError(json.errorMessage);
            } else {
                dispatch(deleteBid(bidID));
            }
            console.log('renderBidItem DeleteBid:', json);
        } catch (err: any) {
            console.error('renderBidItem DeleteBid Error:', err.message);
        }
    };

    const handleExtendBid = async (bidID: string) => {
        Swal.fire({
            title: 'Extend Bid',
            text: `This will extend bid ${bidID} by 15 days from todays date.`,
            icon: 'info',
            showCancelButton: true,
            cancelButtonColor: 'red',
            confirmButtonText: 'Continue',
            confirmButtonColor: '#f1b434',
            showLoaderOnConfirm: false,
            allowOutsideClick: () => !Swal.isLoading(),
            preConfirm: async () => {
                try {
                    await extendBid(bidID);
                } catch (err: any) {
                    Swal.showValidationMessage(err.message);
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Bid Extended',
                    text: 'Bid has been extended by 15 days',
                    icon: 'success',
                    confirmButtonColor: '#f1b434'
                })
                
                logEvent(analytics, 'extend_bid_web', {
                    name: 'extend bid',
                    description: 'User pressed extend bid'
                })
            };
        });

    };

    const extendBid = async (bidID: string) => {
        try {
            const baseUrl = 'https://customer.hirsch.com/bids/v2/extend'
            const res = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                },
                body: JSON.stringify({ id: bidID })
            })

            const json = await res.json();

            if (!json.ack) throw new Error(json.errorMessage);

        } catch (err: any) {
            console.error(err.message)
        }
    }

    const handleDeleteModal = async (id: string) => {
        setbidID(id)
        setDeleteModalOpen(true);
        logEvent(analytics, 'delete_bid_web', {
            name: 'delete bid modal',
            description: 'User opened bid delete menu'
        })
    }

    return (
        <>
            <SwipeableList
                type={SwipeableType.IOS}
                fullSwipe
            >
                <SwipeableListItem
                    key={item.quoteID}
                    trailingActions={
                        <RightAction 
                            onDelete={() => {
                                Swal.fire({
                                    title: 'Delete Bid',
                                    text: alertMessage,
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Delete',
                                    confirmButtonColor: 'red',
                                    showLoaderOnConfirm: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        handleDeleteModal(item.quoteID);
                                    };
                                });
                            }}
                        />
                    }
                >
                    <Card
                        style={{ 
                            display: 'flex', 
                            cursor: 'default', 
                            userSelect: 'none',
                            width: '100%',
                            alignItems: 'center'
                        }}
                    >
                        <div
                            style={{ 
                                flex: 1, 
                                display: 'flex', 
                                textAlign: 'start', 
                                paddingInlineStart: 20,
                                paddingBlock: 10,
                                width: '100%' 
                            }}
                        >
                            <div style={{ flex: 1, display: 'block', padding: 5 }}>
                                <div>
                                    <span className='itemName fw-bold fs-4 d-block'>Quote ID:</span>
                                    <span className='fw-bold fs-4'>{item.quoteID}</span>
                                </div>
                                <div>
                                    <span className='itemDescription d-block'>Customer: {item.billName}</span>
                                    <span className='itemDescription d-block'>Amount: ${item.bidValue}</span>
                                    <span className='itemDescription d-block'>Created: {item.created}</span>
                                    <span className='itemDescription d-block'>Expires: {item.expires}</span>
                                    {/* <span className='itemDescription d-block'>Bid Amount: {usdFormat.format(bidTotal)}</span> */}
                                    <span className='itemDescription d-block'>{`Cust Phone: `}
                                        <a 
                                            onClick={() => makeCall(formatPhoneLink(item.billPhone))}
                                            style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                                <span style={{ textDecorationColor: 'underline', color: '#0000FF'}}>{formatPhone(item.billPhone)}</span>
                                        </a>
                                    </span>
                                    {item.quoteType > '' ? 
                                    (
                                        <span className='itemDescription'>Quote Type: {item.quoteType}</span>
                                    ) : (
                                        null
                                    )}
                                </div>
                            </div>
                            <div style={{ flex: 1, display: 'block', padding: 5, }}>
                                <div>
                                    <span className='itemName fw-bold fs-4 d-block'>Status: </span>
                                    <span style={
                                        status === 'Expired' ? { fontWeight: 'bold', color: 'red', fontSize: 24 }
                                        : status === 'Approved' ? { fontWeight: 'bold', color: 'green', fontSize: 24 }
                                        : { fontWeight: 'bold', fontSize: 24 }
                                    }>{status}</span>
                                </div>
                                <div>
                                    <Button
                                        onClick={() => handleSeeDetails(item)}
                                        className='mainButton fw-bold mt-3'
                                    >
                                        See Details
                                    </Button>
                                    <Button
                                        onClick={() => handleBidFollowUp(item)}
                                        className='mainButton fw-bold d-block mt-3'
                                        style={{ background: 'limegreen', borderColor: 'limegreen' }}
                                    >
                                        Follow-Up
                                    </Button>
                                    {status === 'Expired' &&
                                        <Button
                                            className='cardButton fw-bold d-block mt-3'
                                            style={{ backgroundColor: 'lightgray', borderColor: 'lightgray' }}
                                            onClick={() => handleExtendBid(item.quoteID)}
                                        >
                                            <span style={{ fontWeight: 'bold' }}>Extend</span>
                                        </Button>
                                    }
                                </div>
                            </div>
                        </div>
                    </Card>
                </SwipeableListItem>
            </SwipeableList>
            
            {/* <TemplateModal
                visible={templateModalOpen}
                onClose={() => setTemplateModalOpen(false)}
                onConfirm={handleSubmit}
                bidItem={bidItem}
            /> */}
            {deleteModaOpen &&
                <DeleteBidModal 
                    visible={deleteModaOpen}
                    onClose={() => setDeleteModalOpen(false)}
                    onConfirm={handleDeleteBid}
                    bidID={bidID}
                />
            }
        </>
    )
};

export default RenderBidItem;